// The group-create 400 body is a MatGroupValidationResponse whose Errors array sits at
// the TOP LEVEL of the response (response.errors), not nested under data. Read it from
// there first, keeping the nested locations as resilient fallbacks. Pure so the contract
// is unit-testable.
export const extractServerErrors = (response) => {
  const data = response?.data;
  const errors = response?.errors ?? response?.Errors ?? data?.errors ?? data?.Errors;
  return Array.isArray(errors) ? errors : [];
};
